import { jsx as _jsx } from "react/jsx-runtime";
export var IconArrow = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-2 -2 24 24",
  height: "1em",
  width: "1em",
  fill: "currentColor",
  children: /*#__PURE__*/_jsx("path", {
    d: "M13.828 7.172a.997.997 0 0 0-1-1h-6a1 1 0 1 0 0 2h3.586l-3.95 3.95a1 1 0 0 0 1.415 1.414l3.95-3.95v3.586a1 1 0 0 0 2 0v-6zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"
  })
});